module.exports = __webpack_public_path__ + "static/media/22ESCWA18.f4edc4b6.jpg";